export default class Group {
	constructor({id, name, description, address, city, department, country, hour_init, hour_end, resource_id, cy, cx}) {
		this.id = id || 0;
		this.name = name || "";
		this.description = description || "";
		this.address = address || "";
		this.department = department || "";
		this.city = city || "";
		this.country = country || "";
		this.hour_init = hour_init || "08:00:00";
		this.hour_end = hour_end || "09:00:00";
		this.resource_id = resource_id || [];
		this.cy = cy || "";
		this.cx = cx || "";
	}
}
